import {
  GET_SUPPORT_REQUEST,
  GET_CONFORMITY_REPORT,
  SET_SUPPORT_REQUEST,
  SET_CONFORMITY_REPORT
} from 'fixtures/actions'

let initialState = [];
let initialTaskState = null;

export const supportRequests = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUPPORT_REQUEST:
      return [...action.payload];
    default:
      return state;
  }
}

export const conformityReports = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONFORMITY_REPORT:
      return [...action.payload];
    default:
      return state;
  }
}

export const currentSupportReq = (state = initialTaskState, action) => {
  switch (action.type) {
    case SET_SUPPORT_REQUEST:
      return { ...action.payload };
    default:
      return state;
  }
}

export const currentConformityRep = (state = initialTaskState, action) => {
  switch (action.type) {
    case SET_CONFORMITY_REPORT:
      return { ...action.payload };
    default:
      return state;
  }
}
